export const url = 'recherche/tbdata?tablere=';

export const urlListeActionActionDClientPerso = url + 'avtActionlpc&param=';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=article
//liste article
export const urlListeArticle = url + 'article';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=DiverSys&param=0050
//liste parametre
export const urlListeParametre = url + 'DiverSys&param=';
//http://unilog.ddns.net:86/api/ds/formdata?code=DiverSys&val=0009
//ds Parametre ou ds DiverSys
export const urlParametre = 'ds/formdata?code=DiverSys';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFilesAction&param=cv,collaborateur,190026
//liste document par group  et type et File_Lien
export const urlListeFilesAction = url + 'avtFilesAction&param=';
//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFilesR&param=0041,cv,collaborateur
//liste document par group et key et type
export const urlListeFilesR = url + 'avtFilesR&param=';
//liste document par group  et type
export const urlListeFilesR2 = url + 'avtFilesR2&param=';
//liste facture client(by code client) date debut et fin
//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtPieceTClient&param=20100101,20190501,SNCI
export const urlListePieceTClient = url + 'avtPieceTClient&param=';
//liste facture date debut et fin
//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtPieceTAll&param=20000101,20190501
export const urlListePieceTAll = url + 'avtPieceTAll&param=';
//liste facture Regler date debut et fin
//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtPieceTRegler&param=20100101,20190501
export const urlListePieceTRegler = url + 'avtPieceTRegler&param=';
//liste facture Non Regler date debut et fin
//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtPieceTNonRegler&param=20000101,20190501
export const urlListePieceTNonRegler = url + 'avtPieceTNonRegler&param=';
//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionDjointureTiers&param=20170101,20200301
//liste actionD date debut et fin + joiture sur Action + joiture sur tiers
export const urlListeActionDjointureTiers =
  url + 'avtActionDjointureTiers&param=';
//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtListeActionD&param=20170101,20200301,8
// liste actionD+ jointure action pour un col à une date debut et date fin
export const urlListeActionActionDColl = url + 'avtListeActionD&param=';
//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionDClient&param=20170101,20200301,C0004
// liste actionD+ jointure action pour un client à une date debut et date fin
export const urlListeActionActionDClient = url + 'avtActionDClient&param=';
// liste actionD pour lst col à une date debut et date fin
// EX: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtactionDColF&param=10;8;70,2018-12-1,2019-12-31
export const urlavtactionDColDate = url + 'avtactionDColF&param=';
// liste actionD pour lst col à une date debut et date fin
// EX: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionDEquip&param=10;8;70,2018-12-1,2019-12-31
export const urlavtactionDMachineDate = url + 'avtActionDEquip&param=';
// liste action pour une liste code actionD
// Ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionLAD&param=3521;3529;3532
export const urlListeActionLAD = url + 'avtActionLAD&param=';
// liste actionD pour une liste code action
// Ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionDLA&param=190008;190001
export const urlavtActionDLA = url + 'avtActionDLA&param=';
// liste action pour une code client
// Ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionClient&param=C0009
export const urlListeActionClient = url + 'avtActionClient&param=';
// Liste actionD à une date debut et date fin
// ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionDDF&param=2018-12-1,2019-12-31
export const urlListeAvtActionDDF = url + 'avtActionDDF&param=';
// Liste actionD à une date debut et date fin et code action
// ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionDDF1&param=190001,20181201,20191231
export const urlListeAvtActionDDFCodeAction = url + 'avtActionDDF1&param=';
// liste collaborateur pour une liste de code de competance
// ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtColaboComp&param=ACC1,RespLbabo,RMQ,Sdp
export const urlListeColaboComp = url + 'avtColaboComp&param=';
// liste frais pour une liste de code de coll à une date debut et date fin
// ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFraisColaboDDF&param=10,2018-12-1,2019-12-31
export const urlListeFraisColaboDDF = url + 'avtFraisColaboDDF&param=';
//liste action pour une date debut et fin et type action
// http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionListDDF&param=2018-11-2,2019-11-3,0
export const urlActionListDDF = url + 'avtActionListDDF&param=';
// liste action pour une liste de code collabo
// ex: http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionUnCol&param=10;9
export const urlListeActionCol = url + 'avtActionUnCol&param=';
//liste des taux de km
// ex http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtTauxKm
export const urlListTauxKm = url + 'avtTauxKm';

// model de document pour nouveau coll documents
export const urlListeDocument = url + 'avtDocument';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtActionReferent&param=190027
//liste referent action
export const urlListeActionReferent = url + 'avtActionReferent&param=';
//select max id avtdocMaxId
export const urlavtdocMaxId = url + 'avtdocMaxId';

//liste document pour un collaboaeteur
//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFiles&param=10,collaborateur
export const urlListeDocColl = url + 'avtFiles&param=';
//recherche document par code: retourne un document coder en base46
// http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFilesContent&param=213
export const urlDoc = url + 'avtFilesContent&param=';
//recherche document par code: retourne un document coder en base46
// http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFilesC&param=0041,collaborateur,cv
export const urlFindDoc = url + 'avtFilesC&param=';
//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtListeClient
//tous les Client: code + non + type
export const urlSelectClient = url + 'avtListeClient';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=ListePerso
//tous les Perso: code + non + type
export const urlSelectPerso = url + 'avtListePerso';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=listeAvtAction
//tous les Action: code + non + type
export const urlSelectAction = url + 'avtlisteAction';

//http://unilog.ddns.net:86/api/ds/formdata?code=crmactivity
//ds CrmactivityD pour echange client
export const urlCrmactivity = 'ds/formdata?code=crmactivity';

//http://unilog.ddns.net:86/api/ds/formdata?code=tiersC
//ds Interlocuteur
export const urlInterlocuteur = 'ds/formdata?code=tiersC';

//http://unilog.ddns.net:86/api/ds/formdata?code=avtalerte
//ds alerte
export const urlAlert = 'ds/formdata?code=avtalerte';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtCRMActivity&param=c0034
//liste activity pour code client
export const urlListeCRMActivity = url + 'avtCRMActivity&param=';
//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avttiersc&param=1
//liste Interlocuteur
export const urlListeInterlocuteur = url + 'avttiersc&param=';
//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtalerte&param=c0056
//liste Alert pour un code client
export const urlListeAlert = url + 'avtalerte&param='; //

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=persocontrat
//liste Alert
export const urlListeContrat = url + 'persocontrat'; //

//http://unilog.ddns.net:86/api/recherche/TbRecherche?param=avtalerte
//Column Alert
export const urlColumnAlert =
  'recherche/TbRecherche?param=avtAlerte2' + 'avtalerte'; //

//http://unilog.ddns.net:86/api/recherche/TbRecherche?param=avtCRMActivity
//Column CRMActivity
export const urlColumnCRMActivity =
  'recherche/TbRecherche?param=avtCRMActivity'; //

//http://unilog.ddns.net:86/api/recherche/TbRecherche?param=avttiersc
//Column Interlocuteur
export const urlColumnInterlocuteur = 'recherche/TbRecherche?param=avttiersc'; //

//http://unilog.ddns.net:86/api/recherche/TbRecherche?param=avttiersc
//Column Alert
export const urlColumnEchanfes = 'recherche/TbRecherche?param=avttiersc';

//http://unilog.ddns.net:86/api/gesfiles/contratWordSQL?matricule=0106
// ds contrat
export const urlpersocontrat = 'ds/formdata?code=persocontrat';

//http://unilog.ddns.net:86/api/ds/formdata?code=menu&val=ahmed
//ds menu
export const urlMenu = 'ds/formdata?code=menu';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=menu
//liste menu droit d'accer
export const urlListeMenu = url + 'menu';

//https://backend-uniges.pmc.tn/api/recherche/tbdata?tablere=avtusers
//url liste user
export const urlListeUtilisateur = url + 'avtusers';

//http://unilog.ddns.net:86/api/ds/formdata?code=users
//ds user
export const urlUser = 'ds/formdata?code=users';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtmenu
//liste droit d'accer (fonctions)
export const urlListeDroitAccer = url + 'avtmenu';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtFilesType&param=avtContrat
export const urlListeAllDocumentContrat = url + 'avtFilesType&param=avtContrat';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=ApplyCursus
//liste cursus
export const urlListeApplyCursus = url + 'ApplyCursus';

//liste des matiere pour un code cursus
//http://unilog.ddns.net:86/api/ds/formdata?code=ApplyCursusD
//ds CursusD
export const urlApplyCursusD = 'ds/formdata?code=ApplyCursusD';

//liste des cursus
//http://unilog.ddns.net:86/api/ds/formdata?code=ApplyCursus
//ds Cursus
export const urlApplyCursus = 'ds/formdata?code=ApplyCursus';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=ApplyCursusD
//liste cursusD
export const urlListeApplyCursusD = url + 'ApplyCursusD';

//http://unilog.ddns.net:86/api/recherche/TbRecherche?param=machine
export const urlColumnMachine = 'recherche/TbRecherche?param=machine';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=machine
//liste machine
export const urlListeMachine = url + 'machine';

//http://unilog.ddns.net:86/api/ds/formdata?code=Machine
//ds machine
export const urlMachine = 'ds/formdata?code=Machine';

//http://unilog.ddns.net:86/api/ds/formdata?code=MachineNom&val=m1
//ds Fils machine
export const urlFilsMachine = 'ds/formdata?code=MachineNom';

//http://unilog.ddns.net:86/api/ds/formdata?code=avtActionTypeD
//ds avtActionTypeD
export const urlAvtActionTypeD = 'ds/formdata?code=avtActionTypeD';

export const urlPrintPiece = 'report/pdf?code=tm.rdl';
export const urlListeParamAction = url + 'avtParamAction';
export const urlListeParamColl = url + 'avtParamColl';
//liste collaborateur ou apprenant
export const urlListPerso = url + 'avtperso&param=';
export const urlListFraisCollaborateur = url + 'avtExtFraisMens';
export const urlListClientFull = url + 'tiers';
export const urlListClient = url + 'avtclient2';
export const urlListActionFull = url + 'avtAction';
export const urlListAction = url + 'avtActionList';
export const urlListActionD = url + 'avtActionDList';
export const urlListActionDSearch = url + 'avtActionDcol&param=';
export const urlListActionDSearch2 = url + 'avtActionDPerso&param=';
export const urlListCompetence = url + 'GRHComp';
export const urlListeActionDFull = url + 'avtActionDTot';
export const urlEntetFraisCollaborateur =
  'recherche/TbRecherche?param=avtExtFraisMens';
export const urlListeFraisFull = url + 'avtfrais';

export const urlColumnCollaborateur =
  'recherche/TbRecherche?param=avtcollaborateur';
export const urlColumnClientaborateur = 'recherche/TbRecherche?param=avtclient';

export const urlListeClientByType = url + 'avtclient&param=';
//http://unilog.ddns.net:86/api/ds/formdata?code=avtHeureParam
//ds avtParamHeure
export const urlParamHeure = 'ds/formdata?code=avtHeureParam';

//http://unilog.ddns.net:86/api/recherche/tbdata?tablere=avtHeureParam
//liste avtParamHeure
export const urlListeParamHeure = url + 'avtHeureParam';

//http://unilog.ddns.net:86/api/ds/formdata?code=avtParamAction
//ds avtParamAction
export const urlParamAction = 'ds/formdata?code=avtParamAction';

//http://unilog.ddns.net:86/api/ds/formdata?code=GRHComp
//ds competance
export const urlCompetance = 'ds/formdata?code=GRHComp';

export const urlParamColl = 'ds/formdata?code=avtParamColl';

export const urlFiles = 'ds/formdata?code=avtFiles';
//liste actionD pour code action
export const urlActionD = 'ds/formdata?code=avtactiond&val=';
export const urlAction = 'ds/formdata?code=avtaction';
//retourne actionD vide
export const urlActionD2 = 'ds/formdata?code=avtactiond2';
//ds client
export const urlClient = 'ds/formdata?code=avtclient';
//ds perso //ds collaborateur
export const urlPerso = 'ds/formdata?code=avtPerso';
export const urlAvtfrais = 'ds/formdata?code=avtfrais';
export const urlAvtDoc = 'ds/ajout?dstables=files';

